export const HISTORY_PAGE = "https://amailme.ayesearch.com/ayesearch-browser/history/";
export async function recordSearch(query: string): Promise<void> {
  if (!query.trim() || location.pathname.startsWith("/incognito")) return;
  try {
    // CSRF and session belong to this origin; anonymous events are never persisted.
    await fetch("/api/auth/csrf/", { credentials: "include" });
    const csrf = document.cookie.split("; ").find(x => x.startsWith("csrftoken="))?.slice(10) || "";
    await fetch("/api/history/api/", { method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json", "X-CSRFToken": decodeURIComponent(csrf) },
      body: JSON.stringify({ event_id: crypto.randomUUID(), kind: "search", query,
        url: location.href, title: query, client: "web" }) });
  } catch { /* History availability must never prevent a search. */ }
}
